export const CachingEnum = {
    //Authentication
    LOGIN: "Login",
    FORGOT_PASSWORD: "ForgotPassword",

    //PARENT MENUS - alphabetize for easier looking
    ACCESSIBILITIES: "Accessibilities",
    ADMIN_USERS: "Admin-users",
    BILLINGS: "Billings",
    DASHBOARD: "Dashboard",
    NEWS: "News",
    COMPANIES: "Companies",
    COMPANY_LICENSE_HISTORY: "Company-license-history",
    COMPANY_USERS: "Company-users",
    LICENSES: "Licenses",
    MODULE_SETTING: "Module-Setting",
    PRICE_SETTINGS: "Price-Settings",
    VENDOR: "Vendor",
    REGISTRATION_CODE: "Registration-Codes",
    INSTANCE_MANAGEMENT_LIST: 'Instance-Management-List',
    INSTANCE_STORED_PROCEDURE_LIST: 'Instance-Stored-Procedure-List',
    INSTANCE_AUTO_BACKUP_LIST: 'Instance-Auto-Backup-List',
    INSTANCE_ACTIVITY_LOGS_LIST: 'Instance-Activity-Logs-List',
    DB_INSTANCES_LIST: 'DB-Instances-List',

    //DROPDOWNS - alphabetize for easier looking
    ADMIN_ROLES_LIST: 'AdminRolesList',
    AUTO_DELETE_AFTER_LIST: 'AutoDeleteAfterList',
    BANK_LIST: 'BankList',
    CHECKOUT_STEP_LIST: 'CheckoutStepList',
    COUNTRY_LIST: 'CountryList',
    COMPANY_LIST: 'CompanyList',
    DATASTORAGE_LIST: 'DataStorageList',
    DATA_MODE_LIST: 'DataModeList',
    DESTINATION_LIST: 'DestinationList',
    EWALLET_LIST: 'EWalletList',
    FREQUENCY_LIST: 'FrequencyList',
    LICENSE_PACKAGE_TYPE: 'LicensePackageTypeList',
    LICENSE_TYPE: 'LicenseTypeList',
    NO_OF_USERS_LIST: 'NoOfUsersList',
    PAYMENT_TYPE_LIST: 'PaymentTypeList',
    VALIDITY_LIST: 'ValidityList',
    VALIDITY_TYPE_LIST: 'ValidityTypeList',
    STATUS_LIST: 'StatusList',
    RETENTION_DAYS_LIST: 'RetentionDaysList',
    ROLES_LIST: 'RolesList',
    ADMIN_MODULES: 'AdminModules',
    MODULES_SETTINGS_LIST: 'ModulesSettingsList',
    ACCOUNT_TYPE_LIST: 'AccountTypeList',
    PRICE_SETTINGS_TAB_LIST: 'PriceSettingsTabList',
    ROLE_TYPE_LIST: 'RoleTypeList',
    REGISTRATION_TYPE_LIST: 'RegistrationTypeList',
};
